import React, {useState} from 'react';
import {Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel} from 'react-accessible-accordion';
import PlatformExample from './PlarformExample';
import PopularExample from './PopularExample';
import WrapperStyle from './ExampleDetail.style';
import Drawer from '../../components/UiComponent/drawer';
import ScriptTag from 'react-script-tag';
import {StaticImage} from 'gatsby-plugin-image';
import ExampleDetailDescription from './ExampleDetailDescription'
const OurSolutions = (props) => {
    const {title, description, effects, plan, promotionId, platformExample, galleryId} = props
    return (
      <WrapperStyle>
        <section className="solutions-area pt-100 pb-70">
          <div className="container">

            <div className="row">
              <div className="col-lg-6 col-sm-12">
                <ExampleDetailDescription
                  title={title}
                  description={description}
                  effects={effects}
                  plan={plan}
                />
              </div>
              <div className="col-lg-6 col-sm-12">
                  <div>
                    {(promotionId ? <>
                      <a data-retach-widget="embed" href={`https://retach.biz/promotions/${promotionId}`} rel="nofollow">リタッチ</a>
                      <ScriptTag  type="text/javascript" src="https://retach.biz/scripts/promotionCall.js"/>
                    </>: <>
                      <div data-gallery-import={galleryId}></div>
                      <ScriptTag  type="text/javascript" src="https://retach.biz/scripts/galleryCall.js"/>
                    </>)}

                  </div>
              </div>
            </div>
          </div>
        </section>
        {platformExample}
      </WrapperStyle>
    )
};

export default OurSolutions